module.exports = __webpack_public_path__ + "static/Collaboration-fff7b10ed18ccf0a3448d9907551297a.svg";